<template>
  <el-row class="panel" :class="selectIndex == 1 ? 'homePanel' : ''">
    <header-component
      :selectIndex="selectIndex"
      @changeService="changeService"
    ></header-component>
    <router-view
      :seviceIndex="seviceIndex"
      @changeService="changeService"
    ></router-view>
  </el-row>
</template>
<script>
import headerComponent from "./components/header";
export default {
  components: {
    headerComponent
  },
  watch: {
    $route: "viewpage"
  },
  beforeCreate() {},
  data() {
    return {
      selectIndex: 1,
      seviceIndex: 0
    };
  },
  mounted() {
    // 监管模式下强制跳转到关于我们
    if (window.websiteMode === "supervision" && this.$route.name !== "aboutUs") {
      this.$router.replace({ path: "/aboutUs" });
    }
    switch (this.$route.name) {
      case "home":
        this.selectIndex = 1;
        break;
      case "service":
        this.selectIndex = 2;
        break;
      case "news":
        this.selectIndex = 3;
        break;
      case "newsDetail":
        this.selectIndex = 3;
        break;
      case "aboutUs":
        this.selectIndex = 4;
        break;
    }
  },
  methods: {
    changeService(val) {
      //切记服务页面选项
      this.seviceIndex = val;
    },
    viewpage: function() {
      // 监管模式下强制跳转到关于我们
      if (window.websiteMode === "supervision" && this.$route.name !== "aboutUs") {
        this.$router.replace({ path: "/aboutUs" });
        this.selectIndex = 4;
        return;
      }
      switch (this.$route.name) {
        case "home":
          this.selectIndex = 1;
          break;
        case "service":
          this.selectIndex = 2;
          break;
        case "news":
          this.selectIndex = 3;
          break;
        case "newsDetail":
          this.selectIndex = 3;
          break;
        case "aboutUs":
          this.selectIndex = 4;
          break;
      }
    }
  }
};
</script>
<style>
.panel.homePanel {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/Index.vue